import { getCompletedShipmentsWithLatestStatus } from '../api/adminApi';
import ShipmentsListTable from './ShipmentListTable';

export default function ShipmentsCompletedListTable() {
    return (
        <ShipmentsListTable getShipmentList={getCompletedShipmentsWithLatestStatus}
            noShipmentsMessage='There are no completed shipments.'
            detailsPath='/admin/shipments/completed'
            title='Completed Shipments'
            canEdit={false} />
    );
}